<div class="row" *ngIf="app && app.platformId">
    <div class="col-12 order-1 col-sm-12 col-md-12 col-lg-9 order-lg-0">
        <div class="row">
            <div class="col-12">
              <app-box-archive [type]="'apps'" [id]="app.id"></app-box-archive>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <nb-card accent="primary">
                    <nb-card-header class="d-flex">
                        <span class="mr-auto">Subscription API</span>
                        <a href="https://docs.push.delivery/docs/3.1/references/subscriptions-api/index.html" target="_blank" rel="noopener">
                            <nb-icon icon="question-mark-circle-outline"></nb-icon>
                        </a>
                    </nb-card-header>
                    <nb-card-body>
                        <div class="form-group">
                            <label>URL:</label>
                            <div>{{$basePath | async}}/push-api/</div>
                        </div>

                        <div class="form-group">
                            <label>{{'access_token' | translate }}:</label>
                            <div>{{app.apiUser.accessToken}}</div>
                        </div>

                        <div class="form-group">
                            <label>LegacyAuth.:</label>
                            <div>{{'username' | translate}}: {{app.apiUser.name}}</div>
                            <div>{{'password' | translate}}: {{app.apiUser.clearTextPassword}}</div>
                        </div>

                        <div class="form-group">
                            <label>ClientId:</label>
                            <div>{{clientId}}</div>
                        </div>

                        <div class="form-group">
                            <label>{{'app_id' | translate }}:</label>
                            <div>{{app.id}}</div>
                        </div>

                        <div class="form-group">
                            <label>{{'platform_id' | translate }}:</label>
                            <div>{{app.platformId}}</div>
                        </div>
                    </nb-card-body>
                </nb-card>
            </div>

            <div class="col-12 col-xl-6">
                <nb-card accent="primary">
                    <nb-card-header class="d-flex">
                        <span class="mr-auto">Notification + Admin API</span>
                        <a href="https://docs.push.delivery/docs/3.1/references/push-api/index.html" target="_blank" rel="noopener">
                            <nb-icon icon="question-mark-circle-outline"></nb-icon>
                        </a>
                    </nb-card-header>
                    <nb-card-body>
                        <div class="form-group">
                            <label>Notification URL:</label>
                            <div>{{$basePath | async}}/push-api/</div>
                        </div>

                        <div class="form-group">
                            <label>Admin URL:</label>
                            <div>{{$basePath | async}}/push-admin-api/</div>
                        </div>

                        <div class="form-group">
                            <label>{{'access_token' | translate }}:</label>
                            <div>{{($custCred | async)?.accessToken}}</div>
                        </div>

                        <div class="form-group">
                            <label>LegacyAuth.:</label>
                            <div>{{'username' | translate}}: {{($custCred | async)?.name}}</div>
                            <div>{{'password' | translate}}: {{($custCred | async)?.clearTextPassword}}</div>
                        </div>

                        <div class="form-group">
                            <label>ClientId:</label>
                            <div>{{clientId}}</div>
                        </div>

                        <div class="form-group">
                            <label>{{'app_id' | translate }}:</label>
                            <div>{{app.id}}</div>
                        </div>
                    </nb-card-body>
                </nb-card>
            </div>
        </div>
    </div>

    <div class="col-12 order-0 col-sm-12 col-md-12 col-lg-3 order-lg-1">
        <div class="sidebar">
            <nb-card>
                <nb-card-body>
                    <button (click)="testpush()" nbButton size="medium" fullWidth status="primary">
                        <nb-icon icon="navigation-2-outline"></nb-icon>Test Push
                    </button>

                    <br />
                    <br />
                    <br />

                    <button (click)="edit()" nbButton size="medium" fullWidth status="primary">
                        <nb-icon icon="edit-outline"></nb-icon>{{'edit' | translate }}
                    </button>

                    <br />
                    <br />
            
                    <button nbButton (click)="location.back()" size="medium" fullWidth status="primary">
                      <nb-icon icon="arrow-back-outline"></nb-icon>{{'back' | translate }}
                    </button>
                </nb-card-body>
            </nb-card>

            <app-box-subscribers *ngIf="app" [type]="'app'" [entity]="app"></app-box-subscribers>
        </div>
    </div>
</div>


